import { css } from 'styled-system/css';

export const oddsTableStyle = {
	tooltip: css({
		base: {
			position: 'absolute', 
			height: 'fit-content',
			_ltr: {
				'&[data-newbie="true"]': {
					top: '40px',
					left: 'calc(6px + ((100% - 12px) / 3 / 2) - 10px)',
					md: {
						top: '45px',
					},
				},
				'&[data-newbie="false"]': {
					top: '12px',
					left: 'calc(130px + ((100% - 160px) / 3 / 2) - 10px)',
					md: {
						top: '-15px',
						left: 'calc(180px + ((100% - 210px) / 3 / 2) - 10px)',
					},
					lg: {
						left: 'calc(180px + ((100% - 210px) / 6 / 2) - 10px)',
					},
				}
			},
			_rtl: {
				'&::before': {
					right: '10px',
				},
				'&[data-newbie="true"]': {
					top: '40px',
					right: 'calc(6px + ((100% - 12px) / 3 / 2) - 10px)',
					md: {
						top: '45px',
					},
				},
				'&[data-newbie="false"]': {
					top: '12px',
					right: 'calc(130px + ((100% - 160px) / 3 / 2) - 10px)',
					md: {
						top: '-15px',
						right: 'calc(180px + ((100% - 210px) / 3 / 2) - 10px)',
					},
					lg: {
						right: 'calc(180px + ((100% - 210px) / 6 / 2) - 10px)',
					},
				}
			}
		}
	}),
}